
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1501Dialog extends Serenity.EntityDialog<Report_1501Row, any> {
        protected getFormKey() { return Report_1501Form.formKey; }
        protected getIdProperty() { return Report_1501Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1501Row.localTextPrefix; }
        protected getNameProperty() { return Report_1501Row.nameProperty; }
        protected getService() { return Report_1501Service.baseUrl; }
        protected getDeletePermission() { return Report_1501Row.deletePermission; }
        protected getInsertPermission() { return Report_1501Row.insertPermission; }
        protected getUpdatePermission() { return Report_1501Row.updatePermission; }

        protected form = new Report_1501Form(this.idPrefix);

    }
}